// extracted by mini-css-extract-plugin
export var fadeIn = "_bj-0";